// Pure string constants used across multiple layers. These are intentionally
// platform-agnostic (no `import.meta.env`); environment-coupled flags live on
// the `env` object in `@infra/config/env`.
export const CREATE_NEW_GROWER = "Create new grower...";
export const CREATE_NEW_SALESPERSON = "Create new salesperson...";
export const FOLDER_TOKEN_PREFIX = "Folder Level ";
export const INVALID_USERCONTEXT = "Authentication error. Try logging out and back in.";
export const DEFAULT_PAGE: string = "/home";

/** Rogo HQ coordinates — default map center / "Home" target shared by all map widgets. */
export const ROGO_HQ = { latitude: 40.766677885528274, longitude: -87.16537645341124 } as const;
